






















































































































































































































































































import { Form as elForm } from "element-ui";
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetAllProject,
  GetCrfs,
  DeleteCRF,
  RenameCRF,
  StopPublish,
  GoPublish,
  GetCount,
  GetQRcode,
  GetToken,
} from "@/request/projects";
import Copy from "@/components/copy.vue";
import SimplePagination from "@/components/simple_pagination.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
@Component({
  components: {
    Copy,
    SimplePagination,
    MainHeader,
    LeftNav,
  },
})
export default class ProjectCrfList extends Vue {
  private cProject: any = { project_id: "" };
  private projects: any[] = [];
  private state: any = "";
  private sort: any = 0;
  private name: any = "";
  private currentPage: any = 1;
  private pageCount: any = 10;
  private total: any = 0;
  private totalPage: any = 0;
  private crfs: any[] = [];
  private isRename: any = false;
  private isDelete: any = false;
  private isPublish: any = false;
  private isStopPublish: any = false;
  private isEdit: any = false;
  private Citem: any = "";
  private isSetTime: any = false;
  private startTime: any = null;
  private endTime: any = null;
  private isSupportAdd: any = false;
  private showCode: any = false;
  private imgurl: any = "";
  private id: any = "";
  private publishMsg: any = {};
  private disabledStartDate: any = this.beginDate();
  private disabledEndDate: any = this.endDate();
  private renameForm: any = {
    name: "",
  };
  private renameRules: any = {
    name: [{ required: true, message: "请输入新的量表名称", trigger: "blur" }],
  };
  private beginDate() {
    const self = this;
    return {
      disabledDate(time) {
        if (self.endTime) {
          return (
            time.getTime() > new Date(self.endTime).getTime() ||
            time.getTime() < Date.now()
          );
        } else {
          return time.getTime() < Date.now();
        }
      },
    };
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time) {
        if (self.startTime) {
          return new Date(self.startTime).getTime() > time.getTime();
        } else {
          return time.getTime() < Date.now();
        }
      },
    };
  }
  /**
   * @description 获得所有的研究项目
   */
  private fetchAllProjects() {
    GetAllProject(this).then((data: any) => {
      this.projects = data;
    });
  }
  /**
   * @description 获得crf量表
   */
  private fetchCrf() {
    const params: any = {
      params: {
        project_id: this.cProject.project_id,
        current_page: this.currentPage,
        page_count: this.pageCount,
        名称: this.name,
        量表状态: this.state,
        sort_value: this.sort,
      },
    };
    GetCrfs(this, params).then((data: any) => {
      this.crfs = data.templates;
      this.crfs[3].is_center = true;
      this.total = data.total_count;
      this.totalPage = data.total_page;
    });
  }
  /**
   * @description 点击发布按钮
   */
  private clickPublic(item) {
    if (item.is_center) {
      this.$message.warning("此模板不支持发布");
      return;
    }
    this.publishMsg = item;
    this.isPublish = true;
    this.isSetTime = false;
    this.startTime = "";
    this.endTime = "";
    this.isSupportAdd = false;
  }
  /**
   * @description 发布时间设置
   */
  private changeSetTime(e) {
    if (e) {
      this.startTime = "";
      this.endTime = "";
    }
  }
  /**
   * @description 跳转发布页面
   */
  private goPublish() {
    const params = {
      project_id: this.publishMsg.project_id,
      group_id: this.publishMsg.group_id,
      template_id: this.publishMsg.template_id,
      start_publish_at: this.startTime,
      end_publish_at: this.endTime,
      can_create_user: this.isSupportAdd,
      is_publish: true,
    };
    console.log(params);
    if (this.startTime && this.endTime) {
      const time =
        new Date(this.endTime).getTime() - new Date(this.startTime).getTime();
      if (time < 0) {
        this.$message.warning("结束时间必须大于开始时间");
        return;
      } else if (time < 3600) {
        this.$message.warning("结束时间与开始时间间隔必须大于1小时");
        return;
      }
    }
    GoPublish(this, params).then(() => {
      this.$router.push({
        path: "/main/project/crf-publish",
        query: {
          title: this.publishMsg.name,
          template_id: this.publishMsg.template_id,
        },
      });
    });
  }
  /**
   * @description 跳转统计页面
   */
  private goStatistics(name, id) {
    this.$router.push({
      path: "/main/project/crf-statistics",
      query: {
        title: name,
        template_id: id,
      },
    });
  }
  /**
   * @description 点击编辑
   */
  private clickEdit(item) {
    if (item.is_center) {
      this.$message.warning("此模板不支持编辑");
      return;
    }
    this.Citem = item;
    const params = {
      params: {
        template_id: item.template_id,
      },
    };
    GetCount(this, params).then((res) => {
      this.Citem.count = res.count;
      this.isEdit = true;
    });
  }
  /**
   * @description 跳转编辑页面
   */
  private goEdit() {
    this.$router.push({
      path: "/main/project/crf-edit",
      query: {
        title: this.Citem.name,
        template_id: this.Citem.template_id,
      },
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchCrf();
  }
  /**
   * @description 前一页
   */
  private prev() {
    if (this.currentPage === 1) {
      return;
    } else {
      this.currentPage--;
      this.fetchCrf();
    }
  }
  /**
   * @description 后一页
   */
  private next() {
    if (this.currentPage >= this.totalPage) {
      return;
    } else {
      this.currentPage++;
      this.fetchCrf();
    }
  }
  /**
   * @description 重命名提交
   */
  private submitForm() {
    (this.$refs.renameForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params = {
          template_id: this.Citem.template_id,
          名称: this.renameForm.name,
        };
        RenameCRF(this, params).then((res) => {
          this.isRename = false;
          this.$message.warning("重命名成功");
          this.fetchCrf();
        });
      }
    });
  }
  /**
   * @description 删除
   */
  private handDelete() {
    const params: any = {
      data: {
        template_id: this.Citem.template_id,
      },
    };
    DeleteCRF(this, params).then((res) => {
      this.isDelete = false;
      this.currentPage = 1;
      this.$message.warning("删除成功");
      this.fetchCrf();
    });
  }
  /**
   * @description 删除和重命名
   */
  private handCommand(command, item) {
    this.Citem = item;
    if (command === "删除") {
      this.isDelete = true;
    } else if (command === "重命名") {
      this.isRename = true;
      if (this.$refs.renameForm) {
        (this.$refs.renameForm as elForm).clearValidate();
      }
    } else if (command === "查看二维码") {
      this.id = item.template_id;
      this.getQRCode();
      this.showCode = true;
    }
  }
  /**
   * @description 点击停止发布
   */
  private clickStop(item) {
    this.Citem = item;
    this.isStopPublish = true;
  }
  /**
   * @description 停止发布
   */
  private stopPublish() {
    const params = {
      project_id: this.Citem.project_id,
      template_id: this.Citem.template_id,
    };
    StopPublish(this, params).then((res) => {
      this.isStopPublish = false;
      this.$message.warning("暂停发布成功");
      this.fetchCrf();
    });
  }
  /**
   * @description 提示暂未开发
   */
  private noDevelop() {
    this.$message.warning("暂未开发");
  }
  /**
   * @description 下载二维码
   */
  private downLoadImg() {
    const a = document.createElement("a");
    a.href = this.imgurl;
    a.setAttribute("download", "QRcode");
    a.click();
  }
  private _arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return "data:image/jpeg;base64," + window.btoa(binary);
  }
  private getQRCode() {
    GetToken(this).then((res: any) => {
      const params = {
        scene: this.id,
        page: "pages/index/index",
        access_token: res,
      };
      GetQRcode(this, params).then((data: any) => {
        const qr = this._arrayBufferToBase64(data);
        this.imgurl = qr;
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchAllProjects();
    this.fetchCrf();
  }
}
